/**
 * Move a row one place up or down with a button instead of a drag.
 *
 * Dragging is the fast way when the row is going somewhere nearby and you can see both ends of the
 * journey. It is the slow, fiddly way when a category has to travel past fifteen others on a terminal
 * screen — you hold, you drag to the edge, you wait for the list to auto-scroll, and you hope you let
 * go in the right place. Two buttons do that trip in taps, and they cannot be dropped in the wrong
 * spot. Platform guidelines call this the reorder fallback; on a touch terminal it is closer to the
 * primary route.
 *
 * WHY THIS MOVES THE DOM AND NOT THE ARRAY. These pages already treat the DOM as the order: the save
 * walks `getElementsByTagName('li')` and numbers them, because SortableJS reorders elements directly
 * and never touches the Vue array behind them. Sorting the array here instead would re-render the list
 * from a model that disagrees with what SortableJS has already done to the DOM, and the two would
 * fight. So the buttons do exactly what a drag does.
 */

/** The <li> the pressed button belongs to. */
function rowOf(event) {
  return event.currentTarget.closest('li');
}

/** Briefly marks the row that moved — on touch, the finger is nowhere near it once it lands. */
function flash(row) {
  row.classList.remove('bo_row-moved');
  // Reading offsetWidth restarts the animation; without it a second tap on the same row does nothing.
  void row.offsetWidth;
  row.classList.add('bo_row-moved');
  row.scrollIntoView({ block: 'nearest' });
}

export function moveRowUp(event) {
  const row = rowOf(event);
  const previous = row && row.previousElementSibling;
  if (!previous) {
    return;
  }
  row.parentNode.insertBefore(row, previous);
  flash(row);
}

export function moveRowDown(event) {
  const row = rowOf(event);
  const next = row && row.nextElementSibling;
  if (!next) {
    return;
  }
  row.parentNode.insertBefore(next, row);
  flash(row);
}
